export const RAZOR_KEY_ID = process.env.NEXT_PUBLIC_RAZOR_KEY_ID;
